import { Navigate } from "react-router-dom";

export default function PublicRoute({ children }) {
  let token = localStorage.getItem("coach-admin-token");
  return token ? <Navigate to={`/dashboard`} /> : children;
}
